const LineBreakSvg = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32' fill='none'>
      <g clipPath='url(#clip0_864_2714)'>
        <path
          d='M24 15.0001L25.535 13.5351C26.4458 12.5921 26.9498 11.3291 26.9384 10.0181C26.927 8.70709 26.4011 7.45303 25.4741 6.52599C24.5471 5.59895 23.293 5.0731 21.982 5.06171C20.671 5.05032 19.408 5.55429 18.465 6.46508L17 8.00008'
          stroke='#666666'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M8.00008 17L6.46508 18.465C5.55429 19.408 5.05032 20.671 5.06171 21.982C5.0731 23.293 5.59895 24.5471 6.52599 25.4741C7.45303 26.4011 8.70709 26.927 10.0181 26.9384C11.3291 26.9498 12.5921 26.4458 13.5351 25.535L15.0001 24'
          stroke='#666666'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M24 20H27'
          stroke='#666666'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M5 12H8'
          stroke='#666666'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M20 24V27'
          stroke='#666666'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M12 5V8'
          stroke='#666666'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_864_2714'>
          <rect width='32' height='32' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default LineBreakSvg
